import {
  BookingStatus,
  CaregiverRelationship,
  CaseBalanceType,
  Degree,
  Gender,
  PaymentMethod,
  PaymentMethodForPayroll,
  ProficiencyLevel,
  ScheduleType,
} from './AppEnums';

export const initialUrl = '/'; // this url will open after login
export const AUTH_TOKEN: string = 'app-auth-token-admin';
export const REFRESH_TOKEN_KEY = 'app-refresh-token-admin';
export const TOKEN_EXPIRE_DATE = 'app-auth-expire-admin';
export const USER_INFO: string = 'user-info';
export const COUNT_NOTIFICATIONS: string = 'count-notifications';
export const MAX_AGE = 60 * 60 * 24 * 1;
export const Default_Language: string = 'app-language';
export const FCM_TOKEN_KEY = 'fcm-token';
export const LANGUAGE_HEADER_KEY = 'language-key';
export const PERMISSIONS_KEY = 'permissions';

export const PrimaryColor = '#21aa95';
export const SidebarColor = '#fff';
export const SidebarBackgroundColor = '#fff';
export const UPLOAD_ICON_VALIDATE = [
  'image/svg+xml',
  'image/vnd.microsoft.icon',
  'image/gif',
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/bmp',
  'image/webp',
];

export const formatDateTime: string = 'YYYY-MM-DD hh:mm A';
export const formatDateWithSecondsTime: string = 'YYYY-MM-DD hh:mm:ss A';
export const formatDate: string = 'MMM D, YYYY';
export const formatTimeWithMonthAndDay: string = 'MMM DD hh:mm a';
export const formatTime: string = 'hh:mm a';
export const formatDateInCase: string = 'DD/MM/YYYY';
export const formatDateInVariable: string = 'dddd, MMM DD YYYY - hh:mm A';
export const formatDateInShifts: string = 'ddd, MMM DD - hh:mm A';

export const passwordRegex: any =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&]).{12,}$/;

export const emailRegex: any =
  /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;

export const countryCodeDefault = '+961';

export const remoteServiceBaseUrl = process.env.REACT_APP_PUBLIC_BASE;

export const remoteServiceBaseApiUrl = `${process.env.REACT_APP_PUBLIC_API_BASE}`;

export const remoteSocketIoUrl = process.env.REACT_APP_REMOTE_SOCKETIO_BASE_URL;

export const remoteServiceBaseDomain = process.env.REACT_APP_PUBLIC_DOMAIN;

export const remoteServiceBaseUrlFile = process.env.REACT_APP_BASE_URL_FILE;

export const remoteServiceClientBaseUrl =
  process.env.REACT_APP_PUBLIC_CLIENT_BASE;

export const PRODUCT_NUMBER_IN_ONE_PAGE = 10;
export const PAGE_NUMBER = 1;
export const DISTANCE_DEFAULT = 10;

export const HOURS_PER_SHIFT_COST = 40; // Old Pricing: Pricing of shift we know of
export const HOURS_PER_SHIFT = 12; // Old Hours: Hours of Shift we know of
export const HOURS_PER_SHIFT_IN_CASE = 12; // Old Hours: Hours of Shift we know of in case

export const apiKeyGoogleMap = 'AIzaSyD9SMar9SJqiAdkqiyQzTMyCBnQLzSocoo';

export const INDEX_PAGE_SIZE_DEFAULT = 10;
export const INDEX_PAGE_SIZE_OPTIONS = ['10', '20', '30', '40'];

export const UPLOAD_PICTURE_VALIDATE = [
  'image/gif',
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/bmp',
  'image/webp',
];
export const UPLOAD_FILE_VALIDATE = ['text/plain', 'application/pdf'];

export const CUSTOMER_ROLES = {
  Administrators: 'Administrators',
};

export const FilterOperators = {
  Equals: '==',
  NotEquals: '!=',
  Contains: '@=',
  StringContains: '@=*',
};

export const STEPS_NUMBERS = {
  One: 0,
  Two: 1,
  Three: 2,
  Four: 3,
  Five: 4,
  Six: 5,
  Seven: 6,
  Eight: 7,
  Nine: 8,
  Ten: 9,
  Eleven: 10,
  Twelve: 11,
  Thirteen: 12,
  Fourteen: 13,
  Fifteen: 14,
};

export const GENDER_TYPE = [
  {
    value: Gender.male,
    label: 'male',
  },
  {
    value: Gender.female,
    label: 'female',
  },
  {
    value: Gender.noPreference,
    label: 'noPreference',
  },
];

export const RELATIVITY = [
  {
    value: 1,
    label: 'parent',
  },
  {
    value: 2,
    label: 'mySelf',
  },
  {
    value: 3,
    label: 'spouse',
  },
  {
    value: 4,
    label: 'child',
  },
  {
    value: 5,
    label: 'other',
  },
];

export const WAYS_REFER = {
  Facebook: 'facebook',
  Instagram: 'instagram',
  Twitter: 'twitter',
  Google: 'google',
  Friend: 'friend',
  Other: 'other',
};

export const CASE_DETAILS_SECTION_TABS = [
  {
    value: STEPS_NUMBERS.One,
    label: 'services',
  },
  {
    value: STEPS_NUMBERS.Two,
    label: 'location',
  },
  {
    value: STEPS_NUMBERS.Three,
    label: 'schedule',
  },
  {
    value: STEPS_NUMBERS.Four,
    label: 'budget',
  },
  {
    value: STEPS_NUMBERS.Five,
    label: 'notes',
  },
  {
    value: STEPS_NUMBERS.Six,
    label: 'preferences',
  },
  {
    value: STEPS_NUMBERS.Seven,
    label: 'uploads',
  },
  {
    value: STEPS_NUMBERS.Eight,
    label: 'caseSummary',
  },
  {
    value: STEPS_NUMBERS.Nine,
    label: 'caregiverResponses',
  },
  {
    value: STEPS_NUMBERS.Ten,
    label: 'shiftsAssignment',
  },
  {
    value: STEPS_NUMBERS.Eleven,
    label: 'payment',
  },
];

export const DAYS_OF_WEEK_NAMES = {
  Monday: 'common.monday',
  Tuesday: 'common.tuesday',
  Wednesday: 'common.wednesday',
  Thursday: 'common.thursday',
  Friday: 'common.friday',
  Saturday: 'common.saturday',
  Sunday: 'common.sunday',
};

export const SCHEDULE_TYPE = [
  {
    value: ScheduleType.regular,
    label: 'cases.regular',
  },
  {
    value: ScheduleType.variable,
    label: 'cases.variable',
  },
];

export const CURRENCY = [
  {
    value: 'USD',
    label: 'USD',
  },
];

export const GENERAL_PREFERENCES = {
  isHasACar: 'Have a car',
  isHasAMotorcycle: 'Have a motorcycle',
  isNonSmoker: 'Non-smoker',
  isCatFriendly: 'Cat friendly',
  isDogFriendly: 'Dog friendly',
};

export const AGE_RANGE = {
  UpTo24: 'Up to 24',
  From24To35: '24 - 35',
  From35To50: '35 - 50',
  From50ToAbove: '50 and above',
};

export const AGE_GROUP_TYPE = {
  day: 1,
  month: 2,
  year: 3,
};

export const PAYMENT_METHOD = [
  {
    value: PaymentMethod.OnlinePayment,
    label: 'common.onlinePayment',
  },
  {
    value: PaymentMethod.CashToFAN,
    label: 'common.cashToFAN',
  },
  {
    value: PaymentMethod.CashToCaregiver,
    label: 'common.cashToCaregiver',
  },
  {
    value: PaymentMethod.BobFinance,
    label: 'common.bobFinance',
  },
  {
    value: PaymentMethod.BankOfBeirut,
    label: 'common.bankOfBeirut',
  },
  {
    value: PaymentMethod.OMT,
    label: 'common.OMT',
  },
  {
    value: PaymentMethod.Whish,
    label: 'common.whish',
  },
];

export const CONFIRM_OPTIONS_IN_BOOKING = [
  {
    value: BookingStatus.confirmed,
    label: 'common.confirmed',
  },
  {
    value: BookingStatus.cancelled,
    label: 'common.cancelled',
  },
  {
    value: BookingStatus.onHold,
    label: 'common.onHold',
  },
];

export const PAUSED_OPTIONS_IN_BOOKING = [
  {
    value: BookingStatus.inProgress,
    label: 'common.inProgress',
  },
  {
    value: BookingStatus.paused,
    label: 'common.paused',
  },
];

export const PAYMENT_METHOD_FOR_PAYROLL = [
  {
    value: PaymentMethodForPayroll.BobFinance,
    label: 'common.bobFinance',
  },
  {
    value: PaymentMethodForPayroll.Cash,
    label: 'common.cash',
  },
  {
    value: PaymentMethodForPayroll.Whish,
    label: 'common.whish',
  },
  {
    value: PaymentMethodForPayroll.Other,
    label: 'common.other',
  },
];

export const BobFinanceFeeRanges = [
  {
    min: 1,
    max: 100,
    value: 2,
  },
  {
    min: 100,
    max: 300,
    value: 3,
  },
  {
    min: 300,
    max: 1000,
    value: 4,
  },
  {
    min: 1000,
    max: 2000,
    value: 6,
  },
  {
    min: 2000,
    max: 3000,
    value: 8,
  },
  {
    min: 3000,
    max: 4000,
    value: 9,
  },
  {
    min: 4000,
    max: 5000,
    value: 10,
  },
  {
    min: 5000,
    max: 6000,
    value: 12,
  },
  {
    min: 6000,
    max: 8000,
    value: 14,
  },
  {
    min: 8000,
    max: 10000,
    value: 15,
  },
];

export const CAREGIVER_DETAILS_SECTION_TABS = [
  {
    value: STEPS_NUMBERS.One,
    label: 'generalInfo',
  },
  {
    value: STEPS_NUMBERS.Two,
    label: 'location',
  },
  {
    value: STEPS_NUMBERS.Three,
    label: 'availability',
  },
  {
    value: STEPS_NUMBERS.Four,
    label: 'careCategory',
  },
  {
    value: STEPS_NUMBERS.Five,
    label: 'services',
  },
  {
    value: STEPS_NUMBERS.Six,
    label: 'caregiverRate',
  },
  {
    value: STEPS_NUMBERS.Seven,
    label: 'bio',
  },
  {
    value: STEPS_NUMBERS.Eight,
    label: 'experience',
  },
  {
    value: STEPS_NUMBERS.Nine,
    label: 'education',
  },
  {
    value: STEPS_NUMBERS.Ten,
    label: 'additionalInfo',
  },
  {
    value: STEPS_NUMBERS.Eleven,
    label: 'uploads',
  },
  {
    value: STEPS_NUMBERS.Twelve,
    label: 'reviews',
  },
  {
    value: STEPS_NUMBERS.Thirteen,
    label: 'contacts',
  },
];

export const DEGREE_LIST = [
  {
    value: Degree.None,
    label: 'noneDegree',
  },
  {
    value: Degree.Brevet,
    label: 'brevetOrEquivalent',
  },
  {
    value: Degree.HighSchool,
    label: 'highSchoolOrEquivalent',
  },
  {
    value: Degree.Bachelors,
    label: 'bachelorsDegreeLTOrEquivalent',
  },
  {
    value: Degree.Master,
    label: 'masterDegree',
  },
  {
    value: Degree.PhD,
    label: 'PhD',
  },
];

export const PROFICIENCY_LEVEL = [
  {
    value: ProficiencyLevel.NoProficiency,
    label: 'noProficiency',
  },
  {
    value: ProficiencyLevel.Beginner,
    label: 'beginner',
  },
  {
    value: ProficiencyLevel.Intermediate,
    label: 'intermediate',
  },
  {
    value: ProficiencyLevel.Advanced,
    label: 'advanced',
  },
  {
    value: ProficiencyLevel.Native,
    label: 'native',
  },
];

export const CAREGIVER_RELATION_SHIP_EMERGENCY = [
  {
    value: CaregiverRelationship.family,
    label: 'family',
  },
  {
    value: CaregiverRelationship.friend,
    label: 'friend',
  },
  {
    value: CaregiverRelationship.other,
    label: 'other',
  },
];

export const CAREGIVER_RELATION_SHIP_REFERENCE = [
  {
    value: CaregiverRelationship.previousClient,
    label: 'previousClient',
  },
  {
    value: CaregiverRelationship.colleague,
    label: 'colleague',
  },
  {
    value: CaregiverRelationship.manager,
    label: 'manager',
  },
];

export const CASE_BALANCE_TYPE_LIST = [
  {
    value: CaseBalanceType.UnPaid,
    label: 'shift',
  },
  {
    value: CaseBalanceType.Charge,
    label: 'payment',
  },
  {
    value: CaseBalanceType.Paid,
    label: 'shift',
  },
  {
    value: CaseBalanceType.Refund,
    label: 'refund',
  },
];
